<div class="table-responsive">
  <form>
    <table class="table fm-table__interactive">
      <thead>
        <tr class="header">
          <th>CLASS/POOL</th>
          <th>CUSIP</th>
          <th>ORIGINAL BALANCE</th>
          <th>INTEREST RATE/COUPON</th>
          <ng-container *ngIf="false">
            <th>DELAY?</th>
          </ng-container>
          <ng-container *ngIf="false">
            <th>NOTIONAL</th>
          </ng-container>
          <ng-container *ngIf="false">
            <th>INTEREST TYPE</th>
          </ng-container>
          <th>BALANCE TO FANNIE MAE</th>
          <th>BALANCE TO DEALER</th>
          <ng-container *ngIf="false">
            <th>CURRENT BALANCE EXCHANGED</th>
          </ng-container>
          <ng-container *ngIf="false">
            <th>FINAL DIST. DATE</th>
          </ng-container>
          <ng-container *ngIf="false">
            <th>CURRENT FACTOR</th>
          </ng-container>
        </tr>
      </thead>

      <tbody>
        <tr
          *ngFor="
            let smbsRecom of mRecombinationRows.controls;
            let j = index;
            trackBy: trackByIdentity
          "
        >
          <td [ngClass]="{ 'bond--paid-off': smbsRecom.controls.factor.value === 0 }">
            {{ smbsRecom.controls.remicClass.value }}
            <ng-container *ngIf="smbsRecom.controls.factor.value === 0">
              <span class="bond--paid-off">
                <i
                  class="fa fa-info-circle bonds-disabled-message tooltip-error"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="The bond has been paid off. It will not be included as part of this exchange"
                >
                </i>
              </span>
            </ng-container>
          </td>
          <td [ngClass]="{ 'bond--paid-off': smbsRecom.controls.factor.value === 0 }">
            {{ smbsRecom.controls.cusip.value }}
          </td>
          <td
            class="td_cell--is-numeric"
            [ngClass]="{ 'bond--paid-off': smbsRecom.controls.factor.value === 0 }"
          >
            {{ smbsRecom.controls.exchangeOriginalFace.value | currency: 'USD' : true }}
          </td>

          <td [ngClass]="{ 'bond--paid-off': smbsRecom.controls.factor.value === 0 }">
            {{ smbsRecom.controls.interestRate.value | number: '1.5-5' }}
          </td>
          <ng-container *ngIf="false">
            <td [ngClass]="{ 'bond--paid-off': smbsRecom.controls.factor.value === 0 }">
              {{ smbsRecom.controls.delayDays.value }}
            </td>
            <td [ngClass]="{ 'bond--paid-off': smbsRecom.controls.factor.value === 0 }">
              {{ smbsRecom.controls.notionalFlag.value }}
            </td>
            <td [ngClass]="{ 'bond--paid-off': smbsRecom.controls.factor.value === 0 }">
              {{ smbsRecom.controls.interestType.value }}
            </td>
          </ng-container>

          <td class="toFannieMae form-group">
            <div class="input-group-container">
              <ng-container
                *ngIf="smbsRecom.controls.originalFaceToFNMA.hasError('invalidBondExchange')"
              >
                <i
                  class="fa fa-info-circle input-group-container-addon input-group-container-addon--disabled tooltip-error"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="The amount entered exceeds the allowed balance. Please try again"
                ></i>
              </ng-container>
              <span
                class="currency-addon"
                [ngClass]="{
                  'currency-disabled':
                    smbsRecom.controls.originalFaceToFNMA.hasError('invalidBondExchange'),
                }"
                >$</span
              >
              <input
                type="text"
                [textMask]="{ mask: numberMask }"
                class="input-group--bonds linear__user__flow input-group--bonds"
                [formControl]="smbsRecom.controls.originalFaceToFNMA"
                [class.hasBondError]="
                  smbsRecom.controls.originalFaceToFNMA.hasError('invalidBondExchange')
                "
                [(ngModel)]="smbsRecombinationExchanges.recombinationRows[j].origFaceToFNMA"
                (keydown.enter)="
                  captureBondExchangeEvent($event, smbsRecom.controls.originalFaceToFNMA, j)
                "
                (blur)="captureBondExchangeEvent($event, smbsRecom.controls.originalFaceToFNMA, j)"
              />
            </div>
          </td>

          <td class="toDealer form-group">
            <div class="input-group-container">
              <ng-container
                *ngIf="smbsRecom.controls.originalFaceToDealer.hasError('invalidBondExchange')"
              >
                <i
                  class="fa fa-info-circle input-group-container-addon input-group-container-addon--disabled tooltip-error"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="The amount entered exceeds the allowed balance. Please try again"
                ></i>
              </ng-container>
              <span
                class="currency-addon"
                [ngClass]="{
                  'currency-disabled':
                    smbsRecom.controls.originalFaceToDealer.hasError('invalidBondExchange'),
                }"
                >$</span
              >
              <input
                type="text"
                [textMask]="{ mask: numberMask }"
                class="input-group--bonds linear__user__flow"
                [formControl]="smbsRecom.controls.originalFaceToDealer"
                [class.hasBondError]="
                  smbsRecom.controls.originalFaceToDealer.hasError('invalidBondExchange')
                "
                [(ngModel)]="smbsRecombinationExchanges.recombinationRows[j].origFaceToDealer"
                (keydown.enter)="
                  captureBondExchangeEvent($event, smbsRecom.controls.originalFaceToDealer, j)
                "
                (blur)="
                  captureBondExchangeEvent($event, smbsRecom.controls.originalFaceToDealer, j)
                "
              />
            </div>
          </td>

          <ng-container *ngIf="false">
            <td>
              {{
                smbsRecom.controls.currentBalanceExchanged.value | currency: 'USD' : true : '1.2-2'
              }}
            </td>
            <td>{{ smbsRecom.controls.finalPaymentDate.value | date: 'MM/dd/yyyy' }}</td>
            <td>{{ smbsRecom.controls.factor.value }}</td>
          </ng-container>
        </tr>
      </tbody>
    </table>
  </form>
</div>
